import React from 'react';
import { Sparkles, GraduationCap, Building2, Rocket } from 'lucide-react';

const AboutContent = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12 animate-fade-in" style={{ animationDelay: '0.2s' }}>
      {/* Header */}
      <div className="flex items-center gap-3 mb-8">
        <div className="p-2 bg-gradient-to-r from-green-500 to-blue-500 rounded-xl">
          <Sparkles className="w-6 h-6 text-white" />
        </div>
        <h1 className="text-2xl font-medium text-gray-900 dark:text-gray-100 tracking-tight">
          About Me
        </h1>
      </div>

      {/* Main Content */}
      <div className="prose dark:prose-invert max-w-none">
        <p className="text-base text-gray-600 dark:text-gray-300 leading-relaxed mb-6 font-light tracking-wide">
          I'm a Senior Software Engineer at <a href="https://cyberdesk.io" target="_blank" rel="noopener noreferrer" className="text-green-600 dark:text-green-400 hover:underline font-normal">CyberDesk GmbH</a>, where I build cloud security solutions from the ground up. I graduated from <a href="https://www.nitt.edu/" target="_blank" rel="noopener noreferrer" className="text-green-600 dark:text-green-400 hover:underline font-normal">National Institute of Technology, Tiruchirappalli</a> with a degree in Computer Science.
        </p>

        <p className="text-base text-gray-600 dark:text-gray-300 leading-relaxed mb-6 font-light tracking-wide">
          I'm passionate about early-stage security startups and love building products from scratch. My journey has been focused on scaling security solutions - from architecting high-performance data scanning engines that process millions of documents daily, to building real-time alerting systems that monitor cloud infrastructure across AWS, Azure, and Google Cloud.
        </p>

        <p className="text-base text-gray-600 dark:text-gray-300 leading-relaxed mb-6 font-light tracking-wide">
          Previously at <a href="https://www.proofpoint.com/us/normalyze-is-now-proofpoint" target="_blank" rel="noopener noreferrer" className="text-green-600 dark:text-green-400 hover:underline font-normal">Normalyze</a> (acquired by Proofpoint), I built database connectors for AWS, Azure, and GCP, developed vulnerability scanning systems, and architected distributed data processing workflows. I thrive in environments where I can design systems that handle massive scale - processing terabytes of data daily while maintaining security and performance.
        </p>

        <p className="text-base text-gray-600 dark:text-gray-300 leading-relaxed font-light tracking-wide">
          I write about system design, cloud security, and building scalable applications on my blog. When I'm not coding, I'm exploring new technologies or contributing to open-source projects. I believe in sharing knowledge and helping other developers learn from real-world experiences in building secure, scalable systems.
        </p>
      </div>
    </div>
  );
};

export default AboutContent;
